module.exports = __webpack_public_path__ + "img/boton_jugar.d3ee2f08.png";